import '@stoplight/elements/styles.min.css';

import { StoplightProject } from '@stoplight/elements-dev-portal';
import React from 'react';

export const StoplightProjectDocs: React.FC = () => {
  return (
       <StoplightProject basePath="APIDOCS_V2" projectId="cHJqOjE3NDY2OA" hideMocking={true}/>
  );
};
